import { Alert, Box, Button, Card, CardContent, Typography } from '@mui/material';
import { useGlobalConfig } from 'context/GlobalContext';
import { ROUTE_TREE } from 'routes/AppRoutes';

export const UpdateHistoryPage = () => {
  const { rc } = useGlobalConfig();

  return (
    <Box sx={{ p: { xs: 2, md: 4 } }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2, mb: 2 }}>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            Update History
          </Typography>
          <Typography variant="body2" color="text.secondary">
            View the complete history of configuration updates for this project.
          </Typography>
        </Box>
        <Button variant="outlined" onClick={() => rc.uiRouter.navigate(ROUTE_TREE.PROJECT.DETAILS)}>
          Back to Project Details
        </Button>
      </Box>

      <Card sx={{ borderRadius: 2, boxShadow: 1 }}>
        <CardContent>
          <Alert severity="info">
            UI is being implemented. Next step is to render the project’s config update events (filters + timeline/table).
          </Alert>
        </CardContent>
      </Card>
    </Box>
  );
};

